import {Fragment, useState} from "react";
import _ from "lodash";
import BasicModal from "../../../../../common/BasicModal";
import CannotResolveContainer from "./CannotResolveContainer";
import AppreciationContainer from "./AppreciationContainer";
import useViewMessageDetails from "../../../../Messages/MessageDetails/Utilities/hooks/useViewMessageDetails";
import {getPlatform, PLATFORM} from "../../../../Messages/MessageDetails/Utilities/MessageDetailsUtils";

export default function CannotResolveModal({title, open, handleClose}) {
    const [optionSubmitted, setOptionSubmitted] = useState(false);
    const [adminOptionSubmitted, setAdminOptionSubmitted] = useState(false);
    const {message} = useViewMessageDetails();
    const platform = getPlatform(_.get(message, 'id'));

    const handleOptionSubmitted = (value) => {
        if(platform === PLATFORM.VOTE) {
            setOptionSubmitted(value);
        }else{
            setAdminOptionSubmitted(value)
        }
    }

    const Content = () => {
        if(optionSubmitted) return <AppreciationContainer />;
        return <CannotResolveContainer
            message={message}
            handleClose={handleClose}
            handleOptionSubmitted={handleOptionSubmitted}
            adminOptionSubmitted={adminOptionSubmitted}
        />
    }

    return(
        <Fragment>
            <BasicModal
                title={!optionSubmitted && title}
                withoutCloseIcon={optionSubmitted}
                open={open || optionSubmitted}
                style={{width: '700px'}}
                handleClose={handleClose}>

                <Content />
            </BasicModal>
        </Fragment>
    )
}